
import ArticleList from '~/sections/vision/ai-workspace/list-article.vue'
import SectionTitle from '~/sections/vision/section-title.vue'

export default {
  name: 'AiWorkspaceRelatedArticles',
  components: {
    SectionTitle,
    ArticleList
  },
  props: {
    articles: {
      type: Array,
      default: () => []
    }
  }
}
